// extracted by mini-css-extract-plugin
export default {"socials":"SocialLinks_socials__db0fI","container":"SocialLinks_container__aZbaz","ring":"SocialLinks_ring__d0mDZ"};